<nav id="top-navigation" class="container-fluid">

  <!-- <button type="button" class="collapse-navigation-button" (click)="toggleSideNavigation()"
    [attr.title]="expandButtonTitle()">
    <i class="fa-regular fa-chevron-left" [ngClass]="{'rotate-180': sideNavigationCollapse()}"></i>
  </button> -->

  <div class="row align-items-center gutter-xs">

    <div class="col-auto d-block d-md-none">
      <a [routerLink]="['/']">
        <img src="/assets/img/logo/avux-sm-green.svg" alt="Avux">
      </a>
    </div>

    <div class="col">
      <breadcrumb></breadcrumb>
    </div>


    <div class="col-auto d-none d-sm-block">
      <update-status></update-status>
    </div>

    <div class="col-auto d-none d-sm-block">
      <work-time-indicator></work-time-indicator>
    </div>

    <div class="col-auto d-none d-sm-block">
      <language-select></language-select>
    </div>

    <div class="col-auto d-none d-sm-block">
      <assingment-quick-link></assingment-quick-link>
    </div>

    <div class="col-auto">
      <notification-list></notification-list>
    </div>

    <div class="col-auto">
      <tenant-select-dropmenu></tenant-select-dropmenu>
    </div>

    <div class="col-auto d-none d-sm-block" *ngIf="currentUser">
      <div class="dropdown" dropdown>

        <button id="nav-user-dropdown-btn" dropdownToggle type="button" class="btn btn-link dropdown-toggle"
          aria-controls="nav-user-dropdown-list">
          <i class="fal fa-user fa-lg"></i>
          {{ currentUser.name || "User menu" }}
        </button>

        <ul id="nav-user-dropdown-list" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
          aria-labelledby="nav-user-dropdown-btn">
          <li>
            <a class="dropdown-item" [routerLink]="['/my-account']">
              {{ 'user.my_account.my_account' | translate }}
            </a>
          </li>

          <li *ngIf="isOrgAdmin">
            <a class="dropdown-item" [routerLink]="['/org-management']">
              {{ 'organization.organization_management' | translate }}
            </a>
          </li>

          <li>
            <button type="button" class="dropdown-item" (click)="openLogOutModal()">
              {{ 'login.logout' | translate }}
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-auto" *ngIf="!currentUser">
      <a [routerLink]="['/login/']" class="nav-link">
        <i class="fa fa-fw fa-sign-in"></i>
        {{ 'login.login' | translate }}
      </a>
    </div>

    <div class="col-auto d-sm-none">
      <button type="button" class="side-navigation-toggle" [ngClass]="{'open' : !sideNavigationCollapse()}"
        (click)="toggleSideNavigation()">
        <span class="icon-bar"></span>
      </button>
    </div>

  </div>
</nav>
